import { Component, OnDestroy } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { ToolbarItemFactory } from "../../shared/toolbar";
import { ToolbarItem } from "devextreme/ui/data_grid";
import { MetadataService } from "src/app/services/metadata.service";
import { ClickEvent } from "devextreme/ui/button";

@Component({
  selector: "brd-usecases-form",
  templateUrl: "./usecases-form.component.html",
  styleUrl: "./usecases-form.component.less",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: UsecasesFormComponent,
      multi: true
    }
  ],
  standalone: false
})
export class UsecasesFormComponent implements ControlValueAccessor, OnDestroy {
  selectedUseCases: number[] = [];
  onChange!: (arg0: number[]) => void;
  onTouched: () => void;
  disabled = false;
  filterActive = false;

  customToolbarItems: ToolbarItem[] = [
    ToolbarItemFactory.createButton({
      location: "after",
      text: "Show only selected",
      onClick: (event: ClickEvent) => {
        this.metadataService.setFilterUseCases(this.filterActive ? undefined : this.selectedUseCases);
        event.component.option("text", this.filterActive ? "Show only selected" : "Show all");

        this.filterActive = !this.filterActive;
      }
    })
  ];

  constructor(private metadataService: MetadataService) {}

  ngOnDestroy(): void {
    this.metadataService.setFilterUseCases(undefined);
  }

  writeValue(values: number[]): void {
    this.selectedUseCases = values;
  }
  registerOnChange(fn: (arg0: number[]) => void): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  selectionChanged(values: number[]): void {
    this.selectedUseCases = values;
    this.onChange(values);
    this.onTouched();
  }
}
